import React from 'react';
import { Link } from 'react-router';

class HotelFeedbackLink extends React.Component {

  render() {
    const url = `/feedback/hotel/${this.props.id}`;
    return (
      <Link to={url} target="_blank">Send Feedback</Link>
    );
  }
}
export default HotelFeedbackLink;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelFeedbackLink.js